import { render, staticRenderFns } from "./AnnotationDataBrowser.vue?vue&type=template&id=75bcff6e"
import script from "./AnnotationDataBrowser.vue?vue&type=script&lang=ts"
export * from "./AnnotationDataBrowser.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports